export enum EmailOriginEnum {
  Contact = 'CONTATO',
  Order = 'PEDIDO',
  Calendar = 'AGENDA',
  Titulo = 'TITULO',
}
